import React from 'react'
import classnames from 'classnames'

import { Icon } from '@st-operations/uikit/src/v2/index.js'

/**
 * Renders an audience name as a link to its detail page (opens in a new tab).
 * Falls back to plain text when no href is provided.
 */
const AudienceLink = ({ href, name, id, className }) => {
  if (!href) {
    return (
      <span className={className} title={id}>
        {name}
      </span>
    )
  }

  return (
    <a
      className={classnames(className, 'audience-link')}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={id}
    >
      <span className="audience-link__text">{name}</span>
      <Icon
        className="audience-link__icon"
        icon="externallink"
        type="outline"
        width="14px"
        height="14px"
      />
    </a>
  )
}

export default AudienceLink
